<template>
  <BLayout
    :colors="$site.colors"
    :header-title="title"
    :header-back-route="homeRoute"
    :loading="pending"
    :alert="paging?.total"
    :notice="false"
  >
    <BContainer class="mt-12">
      <BAlert v-if="pending && !(items && items.length)" show variant="warning">
        {{ $t('general.loading') }} ...
      </BAlert>

      <BAlert v-if="!pending && !(items && items.length)" show variant="warning">
        {{ $t('pages.reviews.noReviews') }}
      </BAlert>

      <div class="w-full">
        <div v-if="items && items.length" class="grid sm:grid-cols-4 gap-4">
          <ReviewElementCard
            v-for="(review, index) in items"
            :key="index"
            :review="review"
          />
        </div>

        <p v-if="items" class="mx-auto mt-8 text-center text-sm text-secondary">
          <small class="font-weight-light">{{ $t('pages.reviews.showingNumOfTotal', {items: items.length, total: paging.total}) }}</small>
        </p>

        <div v-if="page < paging?.pages" class="flex justify-center">
          <UButton class="mt-4 mx-auto inline-block" size="lg" :loading="pending" :disabled="pending" @click="page++">
            {{ $t('general.showMore') }} »
          </UButton>
        </div>
      </div>
    </BContainer>
  </BLayout>
</template>

<script setup lang="ts">
const { $api, $site } = useNuxtApp()
const layoutStore = useLayoutStore()
const route = useRoute()

definePageMeta({
  tabs: ['review']
})

useTabMeta('review')

const page = ref(1)
const limit = route.query.limit || 12
 
const { data: response, pending } = await useAsyncData(
  'reviews',
  async (app) => {
    const response = await $api.location.reviews(
      page.value,
      limit
    )

    const previousData = app?._asyncData?.['reviews']?.data.value;

    return {
      reviews: previousData ? [...previousData.reviews, ...response.reviews] : response.reviews,
      paging: response.paging
    }
  },
  {
    watch: [page],
    immediate: true
  }
)

const items = computed(() => response.value?.reviews)
const paging = computed(() => response.value?.paging)

const title = computed(() => {
  return $site.tabs.getName('review', 'Reviews')
})

const info = computed(() => {
  return $site.tabs.getInfo('reviews')
})

const homeRoute = computed(() => {
  return layoutStore.homeRoute || { path: '/' }
})

</script>
